<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "ForecastReportAreaIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
